<template>
    <v-card class="video-border" outlined :style="{ opacity }" />
</template>

<script>
export default {
    props: {
        report: { type: Object, default: () => ({}) },
    },
    computed: {
        opacity() {
            const { audioLevel = 0 } = this.report || {};
            let opacity = audioLevel * 2;
            if (1 < opacity) opacity = 1;
            return opacity;
        },
    },
};
</script>

<style lang="scss" scoped>
.video-border {
    position: absolute;
    top: 0;
    left: 0;

    height: 100%;
    width: 100%;

    border-width: 3px;
    border-style: solid;
    border-color: lawngreen;

    background-color: transparent;

    opacity: 0;

    transition-duration: 0.5;
    transition-property: opacity;
    transition-timing-function: ease-out;
}
</style>